import { AxiosInstance } from "axios";
import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyTypeByCategoryRequestBody, PropertyTypeByCategoryResponse } from "./types";

export class PropertyTypeByCategoryAPI extends BaseAPI<
    PropertyTypeByCategoryRequestBody,
    PropertyTypeByCategoryResponse
> {
    protected route = ApiRoutes.property.typeByCategory;
    protected method = RequestMethod.GET;

    constructor(axios: AxiosInstance, category_id: string) {
        super(axios);
        this.route = ApiRoutes.property.typeByCategory.replace("{category_id}", category_id);
    }
} 